import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForLeafCollectionSummary } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { LeafCollectionSummaryReportSchemaObject } from "../LeafCollectionSummaryReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = "LEAFCOLLECTIONSUMMARYREPORT";

export function LeafCollectionSummaryReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        fromDate: "",
        toDate: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(LeafCollectionSummaryReportSchemaObject).options({ allowUnknown: true });
    const initialContentRownames = ["date", "bagCountFi", "fieldGrossAmount", "fieldNetAmount",
        "factoryGrossAmount", "factoryNetAmount", "glx", "le","percentage"];
    const [contentRowNames, setContentRowNames] = useState([]);
    const initialColumnNames = ["Date", "No of Bags", "Gross /Kg", "Net /Kg", "Gross /Kg", "Net /Kg", "G/L/X", "L/E /Kg","Percentage /%"]
    const [columnNames, setColumnNames] = useState([]);

    const initialCsvHeaders = [
        { label: "Date", value: "date" },
        { label: "Bag Count", value: "bagCountFi" },
        { label: "Field Gross Amount /Kg", value: "fieldGrossAmount" },
        { label: "Field Net Amount /Kg", value: "fieldNetAmount" },
        { label: "Factory Gross Amount /Kg", value: "factoryGrossAmount" },
        { label: "Factory Net Amount /Kg", value: "factoryNetAmount" },
        { label: "G/L/X", value: "glx" },
        { label: "L/E /Kg", value: "glx" },
        { label: "Percentage /%", value: "percentage" }
    ]
    const [csvHeaders, setCsvHeaders] = useState([]);

    const [reportData, setReportData] = useState([]);
    const [fieldDeductions, setFieldDeductions] = useState([]);
    const [factoryDedutions, setFactoryDeductions] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
        clearTableData();
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0"
        });
        clearTableData();
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
        clearTableData();
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            fromDate: target.value,
        });
        clearTableData();
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            toDate: target.value,
        });
        clearTableData();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, LeafCollectionSummaryReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLEAFCOLLECTIONSUMMARYREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getLeafCollectionSummaryReportData(leafCollectionDetails);

        var factoryResultData = result.factoryData;
        var fieldResultData = result.feildData;

        var convertedFactoryData = removeFactoryDataDuplicates(factoryResultData);
        var convertedFieldData = removeFieldDataDuplicates(fieldResultData);

        var finalFactoryResult = factoryDataMergeByDate(convertedFactoryData.finalresult);
        var finalFieldResult = fieldDataMergeByDate(convertedFieldData.finalResult);

        var tableData = mergeFactoryAndFieldData(finalFactoryResult, finalFieldResult);

        var totRecord = {
            date: "Total",
            bagCountFi: 0,
            fieldGrossAmount: 0,
            fieldNetAmount: 0,
            factoryGrossAmount: 0,
            factoryNetAmount: 0,
            glx: 0,
            le: 0
        };

        tableData.forEach(value => {
            for (const property in value) {
                if (!isNaN(value[property])) {
                    totRecord[property] = (totRecord[property] === undefined ? 0 : parseFloat(totRecord[property]))
                        + parseFloat(value[property]);
                }
            }
        });
        totRecord.percentage=((totRecord.le / totRecord.fieldNetAmount) * 100);

        var finalTableData = calPresntage(totRecord,tableData) 

        finalTableData.push(totRecord);

        finalTableData.forEach(x => {

            for (const property in x) {
                if (property !== "date" && property !== "bagCountFi") {
                    x[property] = parseFloat(x[property]).toFixed(2);
                }
            }
        });

        setDynamicHeaders(convertedFactoryData.factoryDeductions, convertedFieldData.fieldDeductions)

        if (finalTableData.length > 0) {
            setIsTableHide(false);
            setReportData(finalTableData);
            createDataTable();
        }
    }

    function setDynamicHeaders(facDeductions, fieDeductions) {
        var copyOfContentRowNames = _.cloneDeep(initialContentRownames);
        var copyOfColumnNames = _.cloneDeep(initialColumnNames);
        var copyOfCsvHeaders = _.cloneDeep(initialCsvHeaders);

        var fieldDeductionsIds = [];
        var fieldDedutionNames = [];
        var factoryDeductionsIds = [];
        var factoryDedutionNames = [];
        var fieldsCsv = [];
        var factoryCsv = [];

        fieDeductions.forEach(x => {
            fieldDeductionsIds.push(x.id);
            fieldDedutionNames.push(x.name);
            fieldsCsv.push(
                { label: x.name, value: x.id }
            )
        });

        facDeductions.forEach(x => {
            factoryDeductionsIds.push(x.id);
            factoryDedutionNames.push(x.name);
            factoryCsv.push(
                { label: x.name, value: x.id }
            )
        });

        copyOfContentRowNames.splice(3, 0, ...fieldDeductionsIds);
        copyOfContentRowNames.splice(5 + factoryDeductionsIds.length, 0, ...factoryDeductionsIds);

        copyOfColumnNames.splice(3, 0, ...fieldDedutionNames);
        copyOfColumnNames.splice(5 + factoryDedutionNames.length, 0, ...factoryDedutionNames);

        copyOfCsvHeaders.splice(3, 0, ...fieldsCsv);
        copyOfCsvHeaders.splice(5 + factoryCsv.length, 0, ...factoryCsv);

        setColumnNames(copyOfColumnNames);
        setContentRowNames(copyOfContentRowNames);
        setCsvHeaders(copyOfCsvHeaders);
    }

    function mergeFactoryAndFieldData(factoryData, FieldData) {
        var merged = _.merge(_.keyBy(factoryData, 'date'), _.keyBy(FieldData, 'date'));
        var values = _.values(merged);

        values.forEach(x => {

            for (const property in x) {
                if (property !== "date" && property !== "bagCountFi") {
                    x[property] = parseFloat(x[property]).toFixed(2);
                }
            }

            var facNet = x.factoryNetAmount === undefined ? 0 : x.factoryNetAmount;
            var fiNet = x.fieldNetAmount === undefined ? 0 : x.fieldNetAmount;
            var facGross = x.factoryGrossAmount === undefined ? 0 : x.factoryGrossAmount;
            var fiGross = x.fieldGrossAmount === undefined ? 0 : x.fieldGrossAmount;

            x.glx = parseFloat(facGross - fiGross).toFixed(2);
            x.le = parseFloat(facNet - fiNet).toFixed(2);
            
        });
        return values;

    }

    function calPresntage(totRecord,tableData){
        
        tableData.forEach(x =>{
            x.percentage = ((x.le / totRecord.fieldNetAmount) * 100);
        });
        return tableData;
    }

    function removeFactoryDataDuplicates(data) {
        var result = [];
        var deductionArray = [];

        var complexResult;

        data.forEach(x => {
            if (result.length === 0) {
                result.push({
                    factoryGrossAmount: x.factoryGrossAmount,
                    factoryNetAmount: x.factoryNetAmount,
                    [x.factoryDeductionTempId + "Fa"]: (x.factoryDeductionAmount),
                    factoryWeighDetailID: x.factoryWeighDetailID,
                    date: x.weightReadTime.split("T")[0]
                });
                deductionArray.push({ id: x.factoryDeductionTempId + "Fa", name: x.deductionTypeName });
            } else {
                var selectedFactoryItem = result.find(y => y.factoryWeighDetailID === x.factoryWeighDetailID);

                if (!selectedFactoryItem) {
                    result.push({
                        factoryGrossAmount: x.factoryGrossAmount,
                        factoryNetAmount: x.factoryNetAmount,
                        [x.factoryDeductionTempId + "Fa"]: (x.factoryDeductionAmount),
                        factoryWeighDetailID: x.factoryWeighDetailID,
                        date: x.weightReadTime.split("T")[0]
                    });
                    deductionArray.push({ id: x.factoryDeductionTempId + "Fa", name: x.deductionTypeName });
                } else {
                    selectedFactoryItem[x.factoryDeductionTempId + "Fa"] = (x.factoryDeductionAmount);
                    deductionArray.push({ id: x.factoryDeductionTempId + "Fa", name: x.deductionTypeName });
                }
            }
        });

        var uniqDeductions = deductionArray.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)

        setFactoryDeductions(uniqDeductions);

        complexResult = {
            finalresult: result,
            factoryDeductions: uniqDeductions
        }

        return complexResult;
    }

    function factoryDataMergeByDate(data) {
        var mergedFactoryDataResult = [];

        var grouped = _.groupBy(data, a => {
            return a.date;
        });

        for (let [key, value] of Object.entries(grouped)) {
            var tempRecord = {};
            var bagCount = value.length;

            value.forEach(x => {
                for (let [k, v] of Object.entries(x)) {
                    if (k !== "date" && k !== "factoryWeighDetailID") {
                        if (!isNaN(k)) {
                            tempRecord[k + "Fa"] = (tempRecord[k + "Fa"] === undefined) ? (v)
                                : (tempRecord[k + "Fa"] + v);
                        } else {
                            tempRecord[k] = (tempRecord[k] === undefined) ? (v)
                                : (tempRecord[k] + v);
                        }
                    } else if (k === "date") {
                        tempRecord.date = v;
                    }
                }
            });
            tempRecord.bagCountFa = bagCount;
            mergedFactoryDataResult.push(tempRecord);
        }

        return mergedFactoryDataResult;
    }

    function removeFieldDataDuplicates(data) {
        var result = [];
        var deductionArray = [];

        var complexResult;

        data.forEach(x => {
            if (result.length === 0) {
                result.push({
                    fieldGrossAmount: x.fieldGrossAmount,
                    fieldNetAmount: x.fieldNetAmount,
                    [x.filedDeductionTempId + "Fi"]: (x.fieldDeductionAmount),
                    productCollectionDetailsID: x.productCollectionDetailsID,
                    date: x.weightReadTime.split("T")[0]
                });
                deductionArray.push({ id: x.filedDeductionTempId + "Fi", name: x.deductionTypeName });
            } else {
                var selectedFactoryItem = result.find(y => y.productCollectionDetailsID === x.productCollectionDetailsID);

                if (!selectedFactoryItem) {
                    result.push({
                        fieldGrossAmount: x.fieldGrossAmount,
                        fieldNetAmount: x.fieldNetAmount,
                        [x.filedDeductionTempId + "Fi"]: (x.fieldDeductionAmount),
                        productCollectionDetailsID: x.productCollectionDetailsID,
                        date: x.weightReadTime.split("T")[0]
                    });
                    deductionArray.push({ id: x.filedDeductionTempId + "Fi", name: x.deductionTypeName });
                } else {
                    selectedFactoryItem[x.filedDeductionTempId + "Fi"] = (x.fieldDeductionAmount);
                    deductionArray.push({ id: x.filedDeductionTempId + "Fi", name: x.deductionTypeName });
                }
            }
        });

        var uniqDeductions = deductionArray.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)

        setFieldDeductions(uniqDeductions);

        complexResult = {
            finalResult: result,
            fieldDeductions: uniqDeductions
        }

        return complexResult;
    }

    function fieldDataMergeByDate(data) {
        var mergedFieldDataResult = [];

        var grouped = _.groupBy(data, a => {
            return a.date;
        });

        for (let [key, value] of Object.entries(grouped)) {
            var tempRecord = {};
            var bagCount = value.length;

            value.forEach(x => {
                for (let [k, v] of Object.entries(x)) {
                    if (k !== "date" && k !== "productCollectionDetailsID") {
                        if (!isNaN(k)) {
                            tempRecord[k + "Fi"] = (tempRecord[k + "Fi"] === undefined) ? (v)
                                : (tempRecord[k + "Fi"] + v);
                        } else {
                            tempRecord[k] = (tempRecord[k] === undefined) ? (v)
                                : (tempRecord[k] + v);
                        }
                    } else if (k === "date") {
                        tempRecord.date = v;
                    }
                }
            });
            tempRecord.bagCountFi = bagCount;
            mergedFieldDataResult.push(tempRecord);
        }

        return mergedFieldDataResult;
    }

    function createDataTable() {
        $("#leafCollectionSummary").DataTable()
    }

    function createFile() {
        var settings = {
            sheetName: 'Leaf Collection Summary Report',
            fileName: 'LeafCollectionSummaryReport',
            writeOptions: {}
        }

        xlsx(initialCsvHeaders, reportData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            fromDate: "",
            toDate: ""
        });
        setErrors("");
        clearTableData();
    }

    function clearTableData() {
        setIsTableHide(true);
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Leaf Collection Summary Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="leafCollectionSummary" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th colSpan="2"></th>
                                                            <th colSpan={2 + fieldDeductions.length} style={{ textAlign: "center" }}>Field Weight /Kg</th>
                                                            <th colSpan={2 + factoryDedutions.length} style={{ textAlign: "center" }}>Factory Weight /Kg</th>
                                                            <th></th>
                                                            <th></th>
                                                        </tr>
                                                        <tr>
                                                            {columnNames.map((x, index) => {
                                                                return (
                                                                    <th key={index}>{x}</th>
                                                                );
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForLeafCollectionSummary
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Leaf Collection Summary Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} columnNames={columnNames} fieldDeductions={fieldDeductions}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} factoryDedutions={factoryDedutions} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
